import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {	
	FETCH_MATERIAL_CODE_ADDITIONAL_ATTRIBUTES: createAsyncActionConstants('FETCH_MATERIAL_CODE_ADDITIONAL_ATTRIBUTES'),
    FETCH_CHARGE_AMENDMENT_EXCEPTIONS: createAsyncActionConstants('FETCH_CHARGE_AMENDMENT_EXCEPTIONS'),
	FETCH_ADHOC_CONTRACTUAL_RATES: createAsyncActionConstants('FETCH_ADHOC_CONTRACTUAL_RATES'),
	FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL: createAsyncActionConstants('FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL'),
	FETCH_CHARGE_SPLIT_RULES: createAsyncActionConstants('FETCH_CHARGE_SPLIT_RULES'),
}
